import { TableActions, TableTypes } from './TableTypes';

const tableReducer = (state: TableTypes, action: TableActions) => {
    switch (action.type) {
        case 'SET_DATA_LENGTH':
            return {
                ...state,
                dataLength: action.payload,
            };
        case 'SET_INITIAL_DATA_LENGTH':
            return {
                ...state,
                initialDataLength: action.payload,
            };
        case 'SET_CUR_PAGE':
            return {
                ...state,
                curPage: action.payload,
            };
        case 'SET_PREV_PAGE':
            return {
                ...state,
                prevPage: action.payload,
            };
        case 'SET_PAGINATION':
            return {
                ...state,
                pagination: action.payload.isPaginated,
                rowPerPage: action.payload.rowPerPage,
            };
        case 'SET_NUMBER_OF_COLUMNS':
            return {
                ...state,
                numOfColumns: action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default tableReducer;
